import React, { useContext, useState, useEffect } from 'react';
import { UserContext } from '../UserContext';
import { useNavigate } from 'react-router-dom';
import FormActionButton from '../components/FormActionButton';
import TextInput from '../components/TextInput';
import Container from '../components/Container';
import Heading2 from '../components/Heading2';

const PersonalInfoScreen: React.FC = () => {
  const userContext = useContext(UserContext);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [birthDate, setBirthDate] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (userContext) {
      const { firstName, lastName, phoneNumber, birthDate } = userContext.userData;
      setFirstName(firstName || '');
      setLastName(lastName || '');
      setPhoneNumber(phoneNumber || '');
      setBirthDate(birthDate || '');
    }
  }, [userContext]);

  if (!userContext) return null;

  const { userData, setUserData } = userContext;

  const handleNext = () => {
    setUserData({ ...userData, firstName, lastName, phoneNumber, birthDate });
    navigate('/personal-address');
  };

  return (
    <Container>
      <Heading2>Tell Us a Bit More About Yourself</Heading2>
      <p className="text-gray-700 mb-6">
        When we book your appointment, we need to make sure your provider has your name, knows how to contact you, and
        that we can verify you're over 18.
      </p>
      <div className="space-y-6">
        <TextInput
          label="First Name"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          placeholder="Jane"
        />
        <TextInput
          label="Last Name"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          placeholder="Smith"
        />
        <TextInput
          label="Phone Number"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="615-867-5309"
        />
        <label className="block">
          <span className="text-lg text-gray-700">Date of Birth</span>
          <input
            type="date"
            value={birthDate}
            onChange={(e) => setBirthDate(e.target.value)}
            className="mt-1 block w-full p-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
          />
        </label>
      </div>
      <div className="flex justify-center mt-8">
        <FormActionButton onClick={handleNext} isLoading={false}>
          Next
        </FormActionButton>
      </div>
    </Container>
  );
};

export default PersonalInfoScreen;
